import React from 'react';
import ErrorIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Grid, Paper, Typography } from '@mui/material';

export function ErrorPage(props: { message?: string }) {
  return (
    <Grid container direction="row" sx={{ justifyContent: 'center' }}>
      <Grid size={{ xs: 12, md: 8 }}>
        <Paper elevation={0} sx={{ p: 2 }}>
          <Typography variant="h4" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ErrorIcon fontSize="inherit" sx={{ mr: 1 }} />
            Error encountered
          </Typography>

          <Typography variant="body1">
            <p>{props.message ?? 'Unknown error.'}</p>
            <p>Please refresh the page and try again, or contact Paragon Support.</p>
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
